module.exports = __webpack_public_path__ + "e71092ff562aad2a1776074be6a8fbe2.svg";